<template>
  <div class="studyItem" @click="$emit('click')">
    <img class="img" :src="obj.cover || require('@/assets/images/img_default_02.png')" alt="">
    <div class="content">
      <div class="title">{{ obj.title || obj.name }}</div>
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'studyItem',
  props: {
    obj: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="less" scoped>
.studyItem {
  margin: 0 auto 20px;
  padding: 30px 20px;
  width: 694px;
  height: 204px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  &:nth-child(1) {
    margin-top: 20px;
  }
  .img {
    width: 216px;
    height: 144px;
    border-radius: 16px;
    overflow: hidden;
    flex-shrink: 0;
  }
  .content {
    height: 100%;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    .title {
      font-size: 28px;
      color: #333444;
    }
  }
}
</style>